import { Component, OnInit, Input, EventEmitter, Output, ElementRef } from '@angular/core';
import { LoginService } from '@serengeti/serengeti-common';

@Component({
	selector: 'app-menu-top-list',
	templateUrl: './toplist.component.html',
	styleUrls: ['./toplist.component.scss']
})
export class TopMenuListComponent implements OnInit {

	@Input() menus: any[];

	@Output() topMenuSelected = new EventEmitter<any>();

	constructor(
		private loginService: LoginService
	) {
	}

	getLoginService(): LoginService {
		return this.loginService;
	}

	ngOnInit() {
	}

	showMenus(menu: any): void {
		this.topMenuSelected.emit(menu);
	}

}
